import { render, staticRenderFns } from "./ConfirmAction.vue?vue&type=template&id=473156bb&scoped=true&"
import script from "./ConfirmAction.vue?vue&type=script&lang=js&"
export * from "./ConfirmAction.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAction.vue?vue&type=style&index=0&id=473156bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473156bb",
  null
  
)

export default component.exports